// extracted by mini-css-extract-plugin
export var content = "_pv-1";
export var fullScreen = "_pv-0";